import * as apiAction from '../actions/verifyRecaptcha';

export const verifyRecaptcha = (customer) => {
  return apiAction.verifyRecaptcha(customer).then(response => {
      console.log("apiAction:");
      console.log(response);
      return response;
  });
};
